<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QYXX8N/tc-custom/9781440501951.jpg?1730489334859" alt="This image is the cover for the book Pregnancy Sucks"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pregnancy Sucks
      </h1>
      <p class="bookDescription body article font2">
        <i>Pregnancy Sucks</i>, by Joanne Kimes and Sanford A. Tisherman, M.D., gives you real solutions to all the annoying and somewhat awkward situations that can unexpectedly arise during your pregnancy.<br/>Did you know that:Farm-fresh butter, or petroleum jelly, works just as well for your itchy belly as a fancy and overpriced "pregnancy" product?If you're put on bedrest, walkie-talkies will allow you to yell at your husband-no matter where he is in the house!Surrounding yourself with regular pillows (don't forget to swipe your husband's) is just as good as buying a special large "pregnancy pillow"-and more adaptable to giving support where you personally need it?Doing the hokey pokey, or taking a warm shower, can ease Braxton Hicks contractions?<br/>Full of insight, hilarity, and practical solutions on every page, Pregnancy Sucks shows how, through it all, you can survive with your health, dignity, and sanity intact!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joanne Kimes, Sanford A. Tisherman
      </h2>
      
      <p class="authorDescription body article">An Adams Media author.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?497ce766